export default [
  {
    path: "auth_lg",
    meta: { title: "灵工认证", cate: "企业认证" },
    component: () =>
      import(/* webpackChunkName: "hr-company-auth" */ "@/pages/system/auth_lg.vue"),
  },
  {
    path: "auth_nlg",
    meta: { title: "灵工认证", cate: "企业认证" },
    component: () =>
      import(/* webpackChunkName: "hr-company-auth" */ "@/pages/system/auth_nlg.vue"),
  },
  {
    path: "auth_emp",
    meta: { title: "实名认证", cate: "企业认证" },
    component: () =>
      import(/* webpackChunkName: "hr-company-auth" */ "@/pages/system/auth_emp.vue"),
  },
];
